import apiClient from '../apiClient';
import { POST_SET_PRIMARY_IMAGE_EXCURSION_URL } from '../apiUrl';

const postSetPrimaryExcursionObjectApi = (id, data) => {
  return apiClient.post(POST_SET_PRIMARY_IMAGE_EXCURSION_URL(id), data);
};

export default postSetPrimaryExcursionObjectApi;
